export default __webpack_public_path__ + "static/media/arrow.fb513a23.svg";